import { NullLogger } from '@fds/wm-typescript-logger';
import { Mdg2StoreModuleEntityFactory } from '../factories/Mdg2StoreModuleEntityFactory.js';
import { registerComponentModule } from '../helpers/store.js';
import 'lodash.set';

const DEFAULT_LOGGER = new NullLogger();
class Mdg2StoreModuleFactory {
  constructor(configuration) {
    var _a;
    this.mdg2Client = configuration.mdg2Client;
    this.options = configuration.options;
    this.logger = (_a = configuration.logger) != null ? _a : DEFAULT_LOGGER;
    if (configuration.store) {
      this.store = configuration.store;
      registerComponentModule(this.store, this);
    }
  }
  getDependencies() {
    return {};
  }
  getModuleEntity(module, options) {
    return Mdg2StoreModuleEntityFactory.getInstance(module, {
      mdg2Client: this.mdg2Client,
      options,
      logger: this.logger,
      store: this.store
    });
  }
}

export { Mdg2StoreModuleFactory };
